import {
  getPromptLibraryContext,
  libraryCheckoutReference,
} from "./promptLibraryConversion";
import { getJourneyCampaignContext } from "./growthJourney";
import { buildOrganizationJourneyUrl } from "./organizationJourney";

// Historical payment identifiers remain for receipt attribution and reporting.
// New cohorts are scoped and quoted; current sales pages do not use this checkout.
export const AI30_CHECKOUT_URL =
  "https://buy.stripe.com/00w14n4f70g7aQ2dbCaMU0K";
export const AI30_PRICE = 2500;
export const AI30_PAYMENT_LINK_ID = "plink_1SOkubImMYrwOaquKsHyJh7E";

export const buildAI30CheckoutUrl = (search: string): string => {
  const reference = libraryCheckoutReference(search);
  const campaign = getJourneyCampaignContext(search);
  if (!reference && !Object.keys(campaign).length) return AI30_CHECKOUT_URL;
  const url = new URL(AI30_CHECKOUT_URL);
  if (reference) url.searchParams.set("client_reference_id", reference);
  const context = getPromptLibraryContext(search);
  const defaults = context ? {
    utm_source: "prompt-library",
    utm_medium: "website",
    utm_campaign: "ai-30",
    utm_content: `${context.library_location}_${context.workflow_slug}`,
  } : {};
  for (const key of [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ] as const) {
    const value = campaign[key];
    if (value)
      url.searchParams.set(key, value);
    else if (key in defaults)
      url.searchParams.set(key, defaults[key as keyof typeof defaults]);
  }
  return url.toString();
};

export const buildAI30StrategyCallUrl = (
  search: string,
  location: string,
): string => {
  const callUrl = new URL(buildOrganizationJourneyUrl("/ai-call", search, { source: "ai-30", location, audience: "organization" }), "https://www.technical-leaders.com");
  const library = getPromptLibraryContext(search);
  if (library) {
    callUrl.searchParams.set("library_source", library.source_page);
    callUrl.searchParams.set("library_location", library.library_location);
  }
  return `${callUrl.pathname}${callUrl.search}`;
};
